import { Schema } from "@comparaonline/marketplace-schema";

import { getHostname } from "../../core/helpers";

type GetTipUrl = (countryCode: string, businessUnitSlug: string, tip: Schema.Education) => string;
export const getTipUrl: GetTipUrl = (countryCode, businessUnitSlug, tip) =>
  `${getHostname(countryCode)}/${businessUnitSlug}/tip/${tip.slug}`;
